import { useContext } from "react";
import PropTypes from "prop-types";

import { CompanyContext } from "../CompanyList/CompanyContext";

const BaseProductDescription = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const productDescription = company.fields.productDescription;
	if (!productDescription) return null;

	return <div className={className}>{productDescription}</div>;
};

export default BaseProductDescription;

BaseProductDescription.propTypes = {
	className: PropTypes.string,
};
